import { render, staticRenderFns } from "./Logout.iframe.component.vue?vue&type=template&id=7fb34042"
import script from "./Logout.iframe.component.vue?vue&type=script&lang=js"
export * from "./Logout.iframe.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports